import { Link } from "@quintype/components";
import React, { useEffect, useState } from "react";
import "./custom-my-account-button.m.css";
import User from "../../../../atoms/other-icons/User";

function CustomMyAccountButton({ onAccountHandler, color }) {
  const [isMobile, setMobile] = useState(false);

  useEffect(() => {
    if (window && window.innerWidth < 767) {
      setMobile(true);
    } else {
      setMobile(false);
    }
  }, []);
  return (
    <div styleName="wrapper" onClick={onAccountHandler}>
      {isMobile ? (
        <Link styleName="my-account-only-icon" target="_blank">
          <User color={color} width="10.31px" height="11.61px" />
        </Link>
      ) : (
        <Link style={{ color: color }} styleName="my-account" target="_blank">
          <User color={color} width="10.31px" height="11.61px" />
          My Account
        </Link>
      )}
    </div>
  );
}

export default CustomMyAccountButton;
